function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

export default {
  methods: {
    $closest: function $closest(name) {
      var parent = this.$parent;

      while (parent != null) {
        if (Utils.type.isObject(parent.spec) && Utils.app.vueName(parent) == name) {
          return parent;
        }

        parent = parent.$parent;
      }
    },
    $validation: function $validation(rules) {
      var augmentedRules = rules || [];
      Utils.type.ifObject(this.spec.validation, function (val) {
        Utils.type.ifObject(val.required, function (spec) {
          augmentedRules = augmentedRules.concat([function (v) {
            return v ? true : spec.message;
          }]);
        });
        Utils.type.ifObject(val.format, function (spec) {
          augmentedRules = augmentedRules.concat([function (v) {
            console.log("VALIDATE1");

            if (v && !v.match(spec.regex)) {
              return spec.message;
            }

            return true;
          }]);
        });
      });
      return augmentedRules;
    },
    // // This can be overridden by the component to ensure that dialogs are shown within the component,
    // // which is necessary for operations requiring certain hierarchy, e.g. submitting a form from a
    // // child dialog.
    // $dialogContainer() {
    //   return document.body;
    // },
    $wsSubscribeEvents: function $wsSubscribeEvents(spec) {
      var _this = this;

      if (!Utils.type.isObject(spec)) {
        return;
      }

      var topicName = spec.topic;
      var events = spec.events;

      if (!Utils.type.isString(topicName) || !Utils.type.isArray(events)) {
        return;
      }

      var ws = window.vueApp.webSocket;
      var channel = ws.channels[topicName];

      if (!channel) {
        console.log("Topic not ready: '".concat(topicName, "'"));
        setTimeout(function () {
          // Wait until $wsInitPhoenixSocket() has executed.
          _this.$wsSubscribeEvents(spec);
        }, 200);
        return;
      }

      var _iterator = _createForOfIteratorHelper(events),
          _step;

      try {
        var _loop = function _loop() {
          var eventName = _step.value;
          console.log("Registering event '".concat(eventName, "'"));
          channel.on(eventName, function (payload) {
            console.debug("Received '".concat(eventName, "' event"), payload);
            Utils.ws.handleResponse(payload.onResponse, _this);
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
};